module.exports = {
    apiKey: "AIzaSyBJ8OCHNiZCYhEUBI75x_g4gXzMVbUFSZY",
    authDomain: "books-db-31d81.firebaseapp.com",
    databaseURL: "https://books-db-31d81.firebaseio.com",
    storageBucket: "books-db-31d81.appspot.com"
  };



/** WEBPACK FOOTER **
 ** ./src/config.js
 **/